import ServerApi from 'shared/lib/api/ServerApi';

class LocalizationApi extends ServerApi {
  constructor() {
    super();
    const getOptions = this.opts;
    this.opts = (bodyExists) => {
      const options = getOptions(bodyExists);
      const headers = { ...options.headers };
      delete headers.Authorization;
      return { ...options, headers };
    };
  }

  getLocalization() {
    return super.get(
      '/developer/app-localization/?page=education-system&polite_form=sie',
      false,
    );
  }
}

export default new LocalizationApi();
